/**
 * /**
 *  * Generated by orval v1.0.0 🍃
 *  * Do not edit manually.
 *  * Citrus API
 *  * API for Citrus platform
 *  *\/
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FailResponse,
  OptimizeChannelDriverListResponse,
  OptimizeChannelDriverListV2Response,
  PaginatedProjectListList,
  PaginatedProjectSolutionDriverAllListResponseList,
  PaginatedProjectSolutionDriverListResponseList,
  PaginatedProjectSolutionDriverListV2ResponseList,
  PaginatedProjectSolutionList,
  PaginatedProjectSolutionListList,
  PaginatedProjectUserList,
  PatchedProjectRequest,
  PatchedProjectSolutionRequest,
  PatchedProjectUserRequest,
  Project,
  ProjectLite,
  ProjectRequest,
  ProjectRetrieveUpdateDeleteProjectSerializerResponse,
  ProjectSolutionCreateResponse,
  ProjectSolutionDeleteResponse,
  ProjectSolutionDriver,
  ProjectSolutionDriverBulkActiveRequestRequest,
  ProjectSolutionDriverBulkActiveResponse,
  ProjectSolutionDriverCreateResponse,
  ProjectSolutionDriverGetResponse,
  ProjectSolutionDriverRequest,
  ProjectSolutionGetResponse,
  ProjectSolutionRequest,
  ProjectSolutionUpdateResponse,
  ProjectUserCreateResponse,
  ProjectUserDeleteResponse,
  ProjectUserGetResponse,
  ProjectUserRequest,
  ProjectUserUpdateResponse,
  ProjectsListParams,
  ProjectsSolutionsAllDriversListParams,
  ProjectsSolutionsChannelsRetrieveParams,
  ProjectsSolutionsDriversListParams,
  ProjectsSolutionsListParams,
  ProjectsSolutionsRetrieveParams,
  ProjectsUsersListParams,
  V2ProjectsListParams,
  V2ProjectsSolutionsChannelsRetrieveParams,
  V2ProjectsSolutionsDriversListParams,
  V2ProjectsSolutionsListParams
} from '../../models';

import { customInstance } from '../../../axios-instance';




/**
 * Retrieve a paginated list of projects with optional client filtering. Admin: all. Manager: own client. User: assigned projects. Create: admin any client, or manager for their own client.
 * @summary List projects
 */
export const projectsList = (
    params?: ProjectsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedProjectListList>(
      {url: `/api/projects/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getProjectsListQueryKey = (params?: ProjectsListParams,) => {
    return [`/api/projects/`, ...(params ? [params]: [])] as const;
    }

    
export const getProjectsListQueryOptions = <TData = Awaited<ReturnType<typeof projectsList>>, TError = unknown>(params?: ProjectsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsList>>> = ({ signal }) => projectsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectsListQueryResult = NonNullable<Awaited<ReturnType<typeof projectsList>>>
export type ProjectsListQueryError = unknown


export function useProjectsList<TData = Awaited<ReturnType<typeof projectsList>>, TError = unknown>(
 params: undefined |  ProjectsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectsList>>,
          TError,
          Awaited<ReturnType<typeof projectsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsList<TData = Awaited<ReturnType<typeof projectsList>>, TError = unknown>(
 params?: ProjectsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectsList>>,
          TError,
          Awaited<ReturnType<typeof projectsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsList<TData = Awaited<ReturnType<typeof projectsList>>, TError = unknown>(
 params?: ProjectsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List projects
 */

export function useProjectsList<TData = Awaited<ReturnType<typeof projectsList>>, TError = unknown>(
 params?: ProjectsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Enhanced ListCreateAPIView that automatically integrates with BaseCitrusPagination
and provides all Citrus functionality for list and create operations.

Usage:
    @extend_schema(tags=['Clients'])
    class ClientListCreateView(CitrusListCreateAPIView):
        serializer_class = ClientSerializer
        queryset = Client.objects.all()
 */
export const projectsCreate = (
    projectRequest: ProjectRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<Project>(
      {url: `/api/projects/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: projectRequest, signal
    },
      );
    }
  


export const getProjectsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsCreate>>, TError,{data: ProjectRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof projectsCreate>>, TError,{data: ProjectRequest}, TContext> => {

const mutationKey = ['projectsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectsCreate>>, {data: ProjectRequest}> = (props) => {
          const {data} = props ?? {};

          return  projectsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof projectsCreate>>>
    export type ProjectsCreateMutationBody = ProjectRequest
    export type ProjectsCreateMutationError = unknown

    export const useProjectsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsCreate>>, TError,{data: ProjectRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectsCreate>>,
        TError,
        {data: ProjectRequest},
        TContext
      > => {

      const mutationOptions = getProjectsCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Auto-wrapped retrieve with proper schema
 * @summary Get project
 */
export const projectsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ProjectRetrieveUpdateDeleteProjectSerializerResponse>(
      {url: `/api/projects/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getProjectsRetrieveQueryKey = (id: string,) => {
    return [`/api/projects/${id}`] as const;
    }

    
export const getProjectsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof projectsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsRetrieve>>> = ({ signal }) => projectsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof projectsRetrieve>>>
export type ProjectsRetrieveQueryError = unknown


export function useProjectsRetrieve<TData = Awaited<ReturnType<typeof projectsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof projectsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsRetrieve<TData = Awaited<ReturnType<typeof projectsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof projectsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsRetrieve<TData = Awaited<ReturnType<typeof projectsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project
 */

export function useProjectsRetrieve<TData = Awaited<ReturnType<typeof projectsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Auto-wrapped full update - delegates to patch for consistency
 * @summary Update project (full)
 */
export const projectsUpdate = (
    id: string,
    projectRequest: ProjectRequest,
 ) => {
      
      
      return customInstance<ProjectRetrieveUpdateDeleteProjectSerializerResponse>(
      {url: `/api/projects/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: projectRequest
    },
      );
    }
  


export const getProjectsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsUpdate>>, TError,{id: string;data: ProjectRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof projectsUpdate>>, TError,{id: string;data: ProjectRequest}, TContext> => {

const mutationKey = ['projectsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectsUpdate>>, {id: string;data: ProjectRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  projectsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof projectsUpdate>>>
    export type ProjectsUpdateMutationBody = ProjectRequest
    export type ProjectsUpdateMutationError = unknown

    /**
 * @summary Update project (full)
 */
export const useProjectsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsUpdate>>, TError,{id: string;data: ProjectRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectsUpdate>>,
        TError,
        {id: string;data: ProjectRequest},
        TContext
      > => {

      const mutationOptions = getProjectsUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Auto-wrapped partial update with proper schema
 * @summary Update project
 */
export const projectsPartialUpdate = (
    id: string,
    patchedProjectRequest: PatchedProjectRequest,
 ) => {
      
      
      return customInstance<ProjectRetrieveUpdateDeleteProjectSerializerResponse>(
      {url: `/api/projects/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedProjectRequest
    },
      );
    }
  


export const getProjectsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsPartialUpdate>>, TError,{id: string;data: PatchedProjectRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof projectsPartialUpdate>>, TError,{id: string;data: PatchedProjectRequest}, TContext> => {

const mutationKey = ['projectsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectsPartialUpdate>>, {id: string;data: PatchedProjectRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  projectsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof projectsPartialUpdate>>>
    export type ProjectsPartialUpdateMutationBody = PatchedProjectRequest
    export type ProjectsPartialUpdateMutationError = unknown

    /**
 * @summary Update project
 */
export const useProjectsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsPartialUpdate>>, TError,{id: string;data: PatchedProjectRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectsPartialUpdate>>,
        TError,
        {id: string;data: PatchedProjectRequest},
        TContext
      > => {

      const mutationOptions = getProjectsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Auto-wrapped deletion with proper schema
 * @summary Delete project
 */
export const projectsDestroy = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/projects/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getProjectsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof projectsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['projectsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  projectsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof projectsDestroy>>>
    
    export type ProjectsDestroyMutationError = unknown

    /**
 * @summary Delete project
 */
export const useProjectsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getProjectsDestroyMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Enhanced ListCreateAPIView that automatically integrates with BaseCitrusPagination
and provides all Citrus functionality for list and create operations.

Usage:
    @extend_schema(tags=['Clients'])
    class ClientListCreateView(CitrusListCreateAPIView):
        serializer_class = ClientSerializer
        queryset = Client.objects.all()
 */
export const projectsSolutionsList = (
    id: string,
    params?: ProjectsSolutionsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedProjectSolutionList>(
      {url: `/api/projects/${id}/solutions/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getProjectsSolutionsListQueryKey = (id: string,
    params?: ProjectsSolutionsListParams,) => {
    return [`/api/projects/${id}/solutions/`, ...(params ? [params]: [])] as const;
    }

    
export const getProjectsSolutionsListQueryOptions = <TData = Awaited<ReturnType<typeof projectsSolutionsList>>, TError = unknown>(id: string,
    params?: ProjectsSolutionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectsSolutionsListQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsSolutionsList>>> = ({ signal }) => projectsSolutionsList(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectsSolutionsListQueryResult = NonNullable<Awaited<ReturnType<typeof projectsSolutionsList>>>
export type ProjectsSolutionsListQueryError = unknown


export function useProjectsSolutionsList<TData = Awaited<ReturnType<typeof projectsSolutionsList>>, TError = unknown>(
 id: string,
    params: undefined |  ProjectsSolutionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectsSolutionsList>>,
          TError,
          Awaited<ReturnType<typeof projectsSolutionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsSolutionsList<TData = Awaited<ReturnType<typeof projectsSolutionsList>>, TError = unknown>(
 id: string,
    params?: ProjectsSolutionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectsSolutionsList>>,
          TError,
          Awaited<ReturnType<typeof projectsSolutionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsSolutionsList<TData = Awaited<ReturnType<typeof projectsSolutionsList>>, TError = unknown>(
 id: string,
    params?: ProjectsSolutionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useProjectsSolutionsList<TData = Awaited<ReturnType<typeof projectsSolutionsList>>, TError = unknown>(
 id: string,
    params?: ProjectsSolutionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsSolutionsListQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Create a project solution. Admin only.
 * @summary Create project solution
 */
export const projectsSolutionsCreate = (
    id: string,
    projectSolutionRequest: ProjectSolutionRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ProjectSolutionCreateResponse>(
      {url: `/api/projects/${id}/solutions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: projectSolutionRequest, signal
    },
      );
    }
  


export const getProjectsSolutionsCreateMutationOptions = <TError = ProjectSolutionCreateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsSolutionsCreate>>, TError,{id: string;data: ProjectSolutionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof projectsSolutionsCreate>>, TError,{id: string;data: ProjectSolutionRequest}, TContext> => {

const mutationKey = ['projectsSolutionsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectsSolutionsCreate>>, {id: string;data: ProjectSolutionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  projectsSolutionsCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectsSolutionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof projectsSolutionsCreate>>>
    export type ProjectsSolutionsCreateMutationBody = ProjectSolutionRequest
    export type ProjectsSolutionsCreateMutationError = ProjectSolutionCreateResponse

    /**
 * @summary Create project solution
 */
export const useProjectsSolutionsCreate = <TError = ProjectSolutionCreateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsSolutionsCreate>>, TError,{id: string;data: ProjectSolutionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectsSolutionsCreate>>,
        TError,
        {id: string;data: ProjectSolutionRequest},
        TContext
      > => {

      const mutationOptions = getProjectsSolutionsCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Retrieve a specific project solution. Pass `include_drivers=false` to omit the nested assigned-driver list (use /all-drivers or v2 /drivers instead).
 * @summary Get project solution
 */
export const projectsSolutionsRetrieve = (
    id: string,
    solutionId: string,
    params?: ProjectsSolutionsRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ProjectSolutionGetResponse>(
      {url: `/api/projects/${id}/solutions/${solutionId}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getProjectsSolutionsRetrieveQueryKey = (id: string,
    solutionId: string,
    params?: ProjectsSolutionsRetrieveParams,) => {
    return [`/api/projects/${id}/solutions/${solutionId}`, ...(params ? [params]: [])] as const;
    }

    
export const getProjectsSolutionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof projectsSolutionsRetrieve>>, TError = ProjectSolutionGetResponse>(id: string,
    solutionId: string,
    params?: ProjectsSolutionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectsSolutionsRetrieveQueryKey(id,solutionId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsSolutionsRetrieve>>> = ({ signal }) => projectsSolutionsRetrieve(id,solutionId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id && solutionId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectsSolutionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof projectsSolutionsRetrieve>>>
export type ProjectsSolutionsRetrieveQueryError = ProjectSolutionGetResponse


export function useProjectsSolutionsRetrieve<TData = Awaited<ReturnType<typeof projectsSolutionsRetrieve>>, TError = ProjectSolutionGetResponse>(
 id: string,
    solutionId: string,
    params: undefined |  ProjectsSolutionsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectsSolutionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof projectsSolutionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsSolutionsRetrieve<TData = Awaited<ReturnType<typeof projectsSolutionsRetrieve>>, TError = ProjectSolutionGetResponse>(
 id: string,
    solutionId: string,
    params?: ProjectsSolutionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectsSolutionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof projectsSolutionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsSolutionsRetrieve<TData = Awaited<ReturnType<typeof projectsSolutionsRetrieve>>, TError = ProjectSolutionGetResponse>(
 id: string,
    solutionId: string,
    params?: ProjectsSolutionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project solution
 */

export function useProjectsSolutionsRetrieve<TData = Awaited<ReturnType<typeof projectsSolutionsRetrieve>>, TError = ProjectSolutionGetResponse>(
 id: string,
    solutionId: string,
    params?: ProjectsSolutionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsSolutionsRetrieveQueryOptions(id,solutionId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Update a specific project solution. Admin only. Driver membership can be replaced wholesale via `drivers` (full list of `{driver_id}` objects) or updated incrementally via `add_driver_ids` / `remove_driver_ids` (lists of dataset IDs) — the latter avoids fetching the full driver list and is preferred by paged config grids.
 * @summary Update project solution
 */
export const projectsSolutionsPartialUpdate = (
    id: string,
    solutionId: string,
    patchedProjectSolutionRequest: PatchedProjectSolutionRequest,
 ) => {
      
      
      return customInstance<ProjectSolutionUpdateResponse>(
      {url: `/api/projects/${id}/solutions/${solutionId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedProjectSolutionRequest
    },
      );
    }
  


export const getProjectsSolutionsPartialUpdateMutationOptions = <TError = ProjectSolutionUpdateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsSolutionsPartialUpdate>>, TError,{id: string;solutionId: string;data: PatchedProjectSolutionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof projectsSolutionsPartialUpdate>>, TError,{id: string;solutionId: string;data: PatchedProjectSolutionRequest}, TContext> => {

const mutationKey = ['projectsSolutionsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectsSolutionsPartialUpdate>>, {id: string;solutionId: string;data: PatchedProjectSolutionRequest}> = (props) => {
          const {id,solutionId,data} = props ?? {};

          return  projectsSolutionsPartialUpdate(id,solutionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectsSolutionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof projectsSolutionsPartialUpdate>>>
    export type ProjectsSolutionsPartialUpdateMutationBody = PatchedProjectSolutionRequest
    export type ProjectsSolutionsPartialUpdateMutationError = ProjectSolutionUpdateResponse

    /**
 * @summary Update project solution
 */
export const useProjectsSolutionsPartialUpdate = <TError = ProjectSolutionUpdateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsSolutionsPartialUpdate>>, TError,{id: string;solutionId: string;data: PatchedProjectSolutionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectsSolutionsPartialUpdate>>,
        TError,
        {id: string;solutionId: string;data: PatchedProjectSolutionRequest},
        TContext
      > => {

      const mutationOptions = getProjectsSolutionsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Delete a specific project solution. Admin only.
 * @summary Delete project solution
 */
export const projectsSolutionsDestroy = (
    id: string,
    solutionId: string,
 ) => {
      
      
      return customInstance<ProjectSolutionDeleteResponse>(
      {url: `/api/projects/${id}/solutions/${solutionId}`, method: 'DELETE'
    },
      );
    }
  


export const getProjectsSolutionsDestroyMutationOptions = <TError = ProjectSolutionDeleteResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsSolutionsDestroy>>, TError,{id: string;solutionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof projectsSolutionsDestroy>>, TError,{id: string;solutionId: string}, TContext> => {

const mutationKey = ['projectsSolutionsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectsSolutionsDestroy>>, {id: string;solutionId: string}> = (props) => {
          const {id,solutionId} = props ?? {};

          return  projectsSolutionsDestroy(id,solutionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectsSolutionsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof projectsSolutionsDestroy>>>
    
    export type ProjectsSolutionsDestroyMutationError = ProjectSolutionDeleteResponse

    /**
 * @summary Delete project solution
 */
export const useProjectsSolutionsDestroy = <TError = ProjectSolutionDeleteResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsSolutionsDestroy>>, TError,{id: string;solutionId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectsSolutionsDestroy>>,
        TError,
        {id: string;solutionId: string},
        TContext
      > => {

      const mutationOptions = getProjectsSolutionsDestroyMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Get all drivers assigned to a project solution, ordered by `-id`. Requires access to the project and solution. Supports `search` (driver name), `ordering` (`id`, `driver__name`; default `-id`) and `dataset_ids` (comma-separated dataset IDs to restrict to).
 * @summary Get all project solution drivers (unfiltered)
 */
export const projectsSolutionsAllDriversList = (
    id: string,
    solutionId: string,
    params?: ProjectsSolutionsAllDriversListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedProjectSolutionDriverAllListResponseList>(
      {url: `/api/projects/${id}/solutions/${solutionId}/all-drivers`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getProjectsSolutionsAllDriversListQueryKey = (id: string,
    solutionId: string,
    params?: ProjectsSolutionsAllDriversListParams,) => {
    return [`/api/projects/${id}/solutions/${solutionId}/all-drivers`, ...(params ? [params]: [])] as const;
    }

    
export const getProjectsSolutionsAllDriversListQueryOptions = <TData = Awaited<ReturnType<typeof projectsSolutionsAllDriversList>>, TError = FailResponse>(id: string,
    solutionId: string,
    params?: ProjectsSolutionsAllDriversListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsAllDriversList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectsSolutionsAllDriversListQueryKey(id,solutionId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsSolutionsAllDriversList>>> = ({ signal }) => projectsSolutionsAllDriversList(id,solutionId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id && solutionId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsAllDriversList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectsSolutionsAllDriversListQueryResult = NonNullable<Awaited<ReturnType<typeof projectsSolutionsAllDriversList>>>
export type ProjectsSolutionsAllDriversListQueryError = FailResponse


export function useProjectsSolutionsAllDriversList<TData = Awaited<ReturnType<typeof projectsSolutionsAllDriversList>>, TError = FailResponse>(
 id: string,
    solutionId: string,
    params: undefined |  ProjectsSolutionsAllDriversListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsAllDriversList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectsSolutionsAllDriversList>>,
          TError,
          Awaited<ReturnType<typeof projectsSolutionsAllDriversList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsSolutionsAllDriversList<TData = Awaited<ReturnType<typeof projectsSolutionsAllDriversList>>, TError = FailResponse>(
 id: string,
    solutionId: string,
    params?: ProjectsSolutionsAllDriversListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsAllDriversList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectsSolutionsAllDriversList>>,
          TError,
          Awaited<ReturnType<typeof projectsSolutionsAllDriversList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsSolutionsAllDriversList<TData = Awaited<ReturnType<typeof projectsSolutionsAllDriversList>>, TError = FailResponse>(
 id: string,
    solutionId: string,
    params?: ProjectsSolutionsAllDriversListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsAllDriversList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all project solution drivers (unfiltered)
 */

export function useProjectsSolutionsAllDriversList<TData = Awaited<ReturnType<typeof projectsSolutionsAllDriversList>>, TError = FailResponse>(
 id: string,
    solutionId: string,
    params?: ProjectsSolutionsAllDriversListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsAllDriversList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsSolutionsAllDriversListQueryOptions(id,solutionId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Retrieve channels with their datasets organized hierarchically, filtered by project solution driver access and client permissions. Each dataset includes its regional_variants (if any) and validation status. Channels without an owner are accessible to all clients. Only datasets assigned to this project solution are included. Supports same validation as flat driver list (frequency, date range, regional coverage).
 * @summary Get channel hierarchy for project solution drivers
 */
export const projectsSolutionsChannelsRetrieve = (
    id: string,
    solutionId: string,
    params?: ProjectsSolutionsChannelsRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OptimizeChannelDriverListResponse>(
      {url: `/api/projects/${id}/solutions/${solutionId}/channels`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getProjectsSolutionsChannelsRetrieveQueryKey = (id: string,
    solutionId: string,
    params?: ProjectsSolutionsChannelsRetrieveParams,) => {
    return [`/api/projects/${id}/solutions/${solutionId}/channels`, ...(params ? [params]: [])] as const;
    }

    
export const getProjectsSolutionsChannelsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof projectsSolutionsChannelsRetrieve>>, TError = FailResponse>(id: string,
    solutionId: string,
    params?: ProjectsSolutionsChannelsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsChannelsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectsSolutionsChannelsRetrieveQueryKey(id,solutionId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsSolutionsChannelsRetrieve>>> = ({ signal }) => projectsSolutionsChannelsRetrieve(id,solutionId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id && solutionId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsChannelsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectsSolutionsChannelsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof projectsSolutionsChannelsRetrieve>>>
export type ProjectsSolutionsChannelsRetrieveQueryError = FailResponse


export function useProjectsSolutionsChannelsRetrieve<TData = Awaited<ReturnType<typeof projectsSolutionsChannelsRetrieve>>, TError = FailResponse>(
 id: string,
    solutionId: string,
    params: undefined |  ProjectsSolutionsChannelsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsChannelsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectsSolutionsChannelsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof projectsSolutionsChannelsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsSolutionsChannelsRetrieve<TData = Awaited<ReturnType<typeof projectsSolutionsChannelsRetrieve>>, TError = FailResponse>(
 id: string,
    solutionId: string,
    params?: ProjectsSolutionsChannelsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsChannelsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectsSolutionsChannelsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof projectsSolutionsChannelsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsSolutionsChannelsRetrieve<TData = Awaited<ReturnType<typeof projectsSolutionsChannelsRetrieve>>, TError = FailResponse>(
 id: string,
    solutionId: string,
    params?: ProjectsSolutionsChannelsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsChannelsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get channel hierarchy for project solution drivers
 */

export function useProjectsSolutionsChannelsRetrieve<TData = Awaited<ReturnType<typeof projectsSolutionsChannelsRetrieve>>, TError = FailResponse>(
 id: string,
    solutionId: string,
    params?: ProjectsSolutionsChannelsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsChannelsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsSolutionsChannelsRetrieveQueryOptions(id,solutionId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get drivers for a specific project solution with date filtering. Each driver includes its regional_variants (if any). Validation rules differ by solution type: IMPACT (id=1) applies stricter validation including minimum observations, consecutive nulls, and missing data percentage checks. OPTIMIZE (id=2) validates frequency, data availability, and regional coverage (if regions specified).
 * @summary Get project solution drivers
 */
export const projectsSolutionsDriversList = (
    id: string,
    solutionId: string,
    params?: ProjectsSolutionsDriversListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedProjectSolutionDriverListResponseList>(
      {url: `/api/projects/${id}/solutions/${solutionId}/drivers`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getProjectsSolutionsDriversListQueryKey = (id: string,
    solutionId: string,
    params?: ProjectsSolutionsDriversListParams,) => {
    return [`/api/projects/${id}/solutions/${solutionId}/drivers`, ...(params ? [params]: [])] as const;
    }

    
export const getProjectsSolutionsDriversListQueryOptions = <TData = Awaited<ReturnType<typeof projectsSolutionsDriversList>>, TError = FailResponse>(id: string,
    solutionId: string,
    params?: ProjectsSolutionsDriversListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsDriversList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectsSolutionsDriversListQueryKey(id,solutionId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsSolutionsDriversList>>> = ({ signal }) => projectsSolutionsDriversList(id,solutionId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id && solutionId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsDriversList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectsSolutionsDriversListQueryResult = NonNullable<Awaited<ReturnType<typeof projectsSolutionsDriversList>>>
export type ProjectsSolutionsDriversListQueryError = FailResponse


export function useProjectsSolutionsDriversList<TData = Awaited<ReturnType<typeof projectsSolutionsDriversList>>, TError = FailResponse>(
 id: string,
    solutionId: string,
    params: undefined |  ProjectsSolutionsDriversListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsDriversList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectsSolutionsDriversList>>,
          TError,
          Awaited<ReturnType<typeof projectsSolutionsDriversList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsSolutionsDriversList<TData = Awaited<ReturnType<typeof projectsSolutionsDriversList>>, TError = FailResponse>(
 id: string,
    solutionId: string,
    params?: ProjectsSolutionsDriversListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsDriversList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectsSolutionsDriversList>>,
          TError,
          Awaited<ReturnType<typeof projectsSolutionsDriversList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsSolutionsDriversList<TData = Awaited<ReturnType<typeof projectsSolutionsDriversList>>, TError = FailResponse>(
 id: string,
    solutionId: string,
    params?: ProjectsSolutionsDriversListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsDriversList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project solution drivers
 */

export function useProjectsSolutionsDriversList<TData = Awaited<ReturnType<typeof projectsSolutionsDriversList>>, TError = FailResponse>(
 id: string,
    solutionId: string,
    params?: ProjectsSolutionsDriversListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsDriversList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsSolutionsDriversListQueryOptions(id,solutionId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Assign a dataset as a driver on a project solution. Admin only (create/modify driver access).
 * @summary Create project solution driver
 */
export const projectsSolutionsDriversCreate = (
    id: string,
    solutionId: string,
    projectSolutionDriverRequest: ProjectSolutionDriverRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ProjectSolutionDriver>(
      {url: `/api/projects/${id}/solutions/${solutionId}/drivers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: projectSolutionDriverRequest, signal
    },
      );
    }
  


export const getProjectsSolutionsDriversCreateMutationOptions = <TError = ProjectSolutionDriverCreateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsSolutionsDriversCreate>>, TError,{id: string;solutionId: string;data: ProjectSolutionDriverRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof projectsSolutionsDriversCreate>>, TError,{id: string;solutionId: string;data: ProjectSolutionDriverRequest}, TContext> => {

const mutationKey = ['projectsSolutionsDriversCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectsSolutionsDriversCreate>>, {id: string;solutionId: string;data: ProjectSolutionDriverRequest}> = (props) => {
          const {id,solutionId,data} = props ?? {};

          return  projectsSolutionsDriversCreate(id,solutionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectsSolutionsDriversCreateMutationResult = NonNullable<Awaited<ReturnType<typeof projectsSolutionsDriversCreate>>>
    export type ProjectsSolutionsDriversCreateMutationBody = ProjectSolutionDriverRequest
    export type ProjectsSolutionsDriversCreateMutationError = ProjectSolutionDriverCreateResponse

    /**
 * @summary Create project solution driver
 */
export const useProjectsSolutionsDriversCreate = <TError = ProjectSolutionDriverCreateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsSolutionsDriversCreate>>, TError,{id: string;solutionId: string;data: ProjectSolutionDriverRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectsSolutionsDriversCreate>>,
        TError,
        {id: string;solutionId: string;data: ProjectSolutionDriverRequest},
        TContext
      > => {

      const mutationOptions = getProjectsSolutionsDriversCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Retrieve a specific project solution driver
 * @summary Get project solution driver
 */
export const projectsSolutionsDriversRetrieve = (
    id: string,
    solutionId: string,
    driverId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ProjectSolutionDriverGetResponse>(
      {url: `/api/projects/${id}/solutions/${solutionId}/drivers/${driverId}`, method: 'GET', signal
    },
      );
    }
  

export const getProjectsSolutionsDriversRetrieveQueryKey = (id: string,
    solutionId: string,
    driverId: string,) => {
    return [`/api/projects/${id}/solutions/${solutionId}/drivers/${driverId}`] as const;
    }

    
export const getProjectsSolutionsDriversRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof projectsSolutionsDriversRetrieve>>, TError = ProjectSolutionDriverGetResponse>(id: string,
    solutionId: string,
    driverId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsDriversRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectsSolutionsDriversRetrieveQueryKey(id,solutionId,driverId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsSolutionsDriversRetrieve>>> = ({ signal }) => projectsSolutionsDriversRetrieve(id,solutionId,driverId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id && solutionId && driverId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsDriversRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectsSolutionsDriversRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof projectsSolutionsDriversRetrieve>>>
export type ProjectsSolutionsDriversRetrieveQueryError = ProjectSolutionDriverGetResponse


export function useProjectsSolutionsDriversRetrieve<TData = Awaited<ReturnType<typeof projectsSolutionsDriversRetrieve>>, TError = ProjectSolutionDriverGetResponse>(
 id: string,
    solutionId: string,
    driverId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsDriversRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectsSolutionsDriversRetrieve>>,
          TError,
          Awaited<ReturnType<typeof projectsSolutionsDriversRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsSolutionsDriversRetrieve<TData = Awaited<ReturnType<typeof projectsSolutionsDriversRetrieve>>, TError = ProjectSolutionDriverGetResponse>(
 id: string,
    solutionId: string,
    driverId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsDriversRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectsSolutionsDriversRetrieve>>,
          TError,
          Awaited<ReturnType<typeof projectsSolutionsDriversRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsSolutionsDriversRetrieve<TData = Awaited<ReturnType<typeof projectsSolutionsDriversRetrieve>>, TError = ProjectSolutionDriverGetResponse>(
 id: string,
    solutionId: string,
    driverId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsDriversRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project solution driver
 */

export function useProjectsSolutionsDriversRetrieve<TData = Awaited<ReturnType<typeof projectsSolutionsDriversRetrieve>>, TError = ProjectSolutionDriverGetResponse>(
 id: string,
    solutionId: string,
    driverId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsSolutionsDriversRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsSolutionsDriversRetrieveQueryOptions(id,solutionId,driverId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Paginated active project members. Admin or manager only. Search name/email.
 * @summary Get project users
 */
export const projectsUsersList = (
    id: string,
    params?: ProjectsUsersListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedProjectUserList>(
      {url: `/api/projects/${id}/users/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getProjectsUsersListQueryKey = (id: string,
    params?: ProjectsUsersListParams,) => {
    return [`/api/projects/${id}/users/`, ...(params ? [params]: [])] as const;
    }

    
export const getProjectsUsersListQueryOptions = <TData = Awaited<ReturnType<typeof projectsUsersList>>, TError = unknown>(id: string,
    params?: ProjectsUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsUsersList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectsUsersListQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsUsersList>>> = ({ signal }) => projectsUsersList(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsUsersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectsUsersListQueryResult = NonNullable<Awaited<ReturnType<typeof projectsUsersList>>>
export type ProjectsUsersListQueryError = unknown


export function useProjectsUsersList<TData = Awaited<ReturnType<typeof projectsUsersList>>, TError = unknown>(
 id: string,
    params: undefined |  ProjectsUsersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsUsersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectsUsersList>>,
          TError,
          Awaited<ReturnType<typeof projectsUsersList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsUsersList<TData = Awaited<ReturnType<typeof projectsUsersList>>, TError = unknown>(
 id: string,
    params?: ProjectsUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsUsersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectsUsersList>>,
          TError,
          Awaited<ReturnType<typeof projectsUsersList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsUsersList<TData = Awaited<ReturnType<typeof projectsUsersList>>, TError = unknown>(
 id: string,
    params?: ProjectsUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsUsersList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project users
 */

export function useProjectsUsersList<TData = Awaited<ReturnType<typeof projectsUsersList>>, TError = unknown>(
 id: string,
    params?: ProjectsUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsUsersList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsUsersListQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Add a user to a project. Admin only.
 * @summary Create project user
 */
export const projectsUsersCreate = (
    id: string,
    projectUserRequest: ProjectUserRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ProjectUserCreateResponse>(
      {url: `/api/projects/${id}/users/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: projectUserRequest, signal
    },
      );
    }
  


export const getProjectsUsersCreateMutationOptions = <TError = ProjectUserCreateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsUsersCreate>>, TError,{id: string;data: ProjectUserRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof projectsUsersCreate>>, TError,{id: string;data: ProjectUserRequest}, TContext> => {

const mutationKey = ['projectsUsersCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectsUsersCreate>>, {id: string;data: ProjectUserRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  projectsUsersCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectsUsersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof projectsUsersCreate>>>
    export type ProjectsUsersCreateMutationBody = ProjectUserRequest
    export type ProjectsUsersCreateMutationError = ProjectUserCreateResponse

    /**
 * @summary Create project user
 */
export const useProjectsUsersCreate = <TError = ProjectUserCreateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsUsersCreate>>, TError,{id: string;data: ProjectUserRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectsUsersCreate>>,
        TError,
        {id: string;data: ProjectUserRequest},
        TContext
      > => {

      const mutationOptions = getProjectsUsersCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Retrieve a specific project user. Admin or manager only.
 * @summary Get project user
 */
export const projectsUsersRetrieve = (
    id: string,
    userId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ProjectUserGetResponse>(
      {url: `/api/projects/${id}/users/${userId}`, method: 'GET', signal
    },
      );
    }
  

export const getProjectsUsersRetrieveQueryKey = (id: string,
    userId: string,) => {
    return [`/api/projects/${id}/users/${userId}`] as const;
    }

    
export const getProjectsUsersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof projectsUsersRetrieve>>, TError = ProjectUserGetResponse>(id: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsUsersRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectsUsersRetrieveQueryKey(id,userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsUsersRetrieve>>> = ({ signal }) => projectsUsersRetrieve(id,userId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id && userId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsUsersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectsUsersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof projectsUsersRetrieve>>>
export type ProjectsUsersRetrieveQueryError = ProjectUserGetResponse


export function useProjectsUsersRetrieve<TData = Awaited<ReturnType<typeof projectsUsersRetrieve>>, TError = ProjectUserGetResponse>(
 id: string,
    userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsUsersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectsUsersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof projectsUsersRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsUsersRetrieve<TData = Awaited<ReturnType<typeof projectsUsersRetrieve>>, TError = ProjectUserGetResponse>(
 id: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsUsersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectsUsersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof projectsUsersRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsUsersRetrieve<TData = Awaited<ReturnType<typeof projectsUsersRetrieve>>, TError = ProjectUserGetResponse>(
 id: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsUsersRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project user
 */

export function useProjectsUsersRetrieve<TData = Awaited<ReturnType<typeof projectsUsersRetrieve>>, TError = ProjectUserGetResponse>(
 id: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsUsersRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsUsersRetrieveQueryOptions(id,userId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Update a project user's access and permissions. Admin only.
 * @summary Update project user
 */
export const projectsUsersPartialUpdate = (
    id: string,
    userId: string,
    patchedProjectUserRequest: PatchedProjectUserRequest,
 ) => {
      
      
      return customInstance<ProjectUserUpdateResponse>(
      {url: `/api/projects/${id}/users/${userId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedProjectUserRequest
    },
      );
    }
  


export const getProjectsUsersPartialUpdateMutationOptions = <TError = ProjectUserUpdateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsUsersPartialUpdate>>, TError,{id: string;userId: string;data: PatchedProjectUserRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof projectsUsersPartialUpdate>>, TError,{id: string;userId: string;data: PatchedProjectUserRequest}, TContext> => {

const mutationKey = ['projectsUsersPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectsUsersPartialUpdate>>, {id: string;userId: string;data: PatchedProjectUserRequest}> = (props) => {
          const {id,userId,data} = props ?? {};

          return  projectsUsersPartialUpdate(id,userId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectsUsersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof projectsUsersPartialUpdate>>>
    export type ProjectsUsersPartialUpdateMutationBody = PatchedProjectUserRequest
    export type ProjectsUsersPartialUpdateMutationError = ProjectUserUpdateResponse

    /**
 * @summary Update project user
 */
export const useProjectsUsersPartialUpdate = <TError = ProjectUserUpdateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsUsersPartialUpdate>>, TError,{id: string;userId: string;data: PatchedProjectUserRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectsUsersPartialUpdate>>,
        TError,
        {id: string;userId: string;data: PatchedProjectUserRequest},
        TContext
      > => {

      const mutationOptions = getProjectsUsersPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Remove a user from a project. Admin only.
 * @summary Delete project user
 */
export const projectsUsersDestroy = (
    id: string,
    userId: string,
 ) => {
      
      
      return customInstance<ProjectUserDeleteResponse>(
      {url: `/api/projects/${id}/users/${userId}`, method: 'DELETE'
    },
      );
    }
  


export const getProjectsUsersDestroyMutationOptions = <TError = ProjectUserDeleteResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsUsersDestroy>>, TError,{id: string;userId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof projectsUsersDestroy>>, TError,{id: string;userId: string}, TContext> => {

const mutationKey = ['projectsUsersDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectsUsersDestroy>>, {id: string;userId: string}> = (props) => {
          const {id,userId} = props ?? {};

          return  projectsUsersDestroy(id,userId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectsUsersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof projectsUsersDestroy>>>
    
    export type ProjectsUsersDestroyMutationError = ProjectUserDeleteResponse

    /**
 * @summary Delete project user
 */
export const useProjectsUsersDestroy = <TError = ProjectUserDeleteResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsUsersDestroy>>, TError,{id: string;userId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectsUsersDestroy>>,
        TError,
        {id: string;userId: string},
        TContext
      > => {

      const mutationOptions = getProjectsUsersDestroyMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Same access as v1. Returns all matching projects (no pagination) with id, name, logo, status, client, and active_solution_ids — for pickers and nav lists (avoids per-project solutions N+1).
 * @summary List projects (v2 lite)
 */
export const v2ProjectsList = (
    params?: V2ProjectsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ProjectLite[]>(
      {url: `/api/v2/projects/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getV2ProjectsListQueryKey = (params?: V2ProjectsListParams,) => {
    return [`/api/v2/projects/`, ...(params ? [params]: [])] as const;
    }

    
export const getV2ProjectsListQueryOptions = <TData = Awaited<ReturnType<typeof v2ProjectsList>>, TError = unknown>(params?: V2ProjectsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV2ProjectsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v2ProjectsList>>> = ({ signal }) => v2ProjectsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V2ProjectsListQueryResult = NonNullable<Awaited<ReturnType<typeof v2ProjectsList>>>
export type V2ProjectsListQueryError = unknown


export function useV2ProjectsList<TData = Awaited<ReturnType<typeof v2ProjectsList>>, TError = unknown>(
 params: undefined |  V2ProjectsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v2ProjectsList>>,
          TError,
          Awaited<ReturnType<typeof v2ProjectsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV2ProjectsList<TData = Awaited<ReturnType<typeof v2ProjectsList>>, TError = unknown>(
 params?: V2ProjectsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v2ProjectsList>>,
          TError,
          Awaited<ReturnType<typeof v2ProjectsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV2ProjectsList<TData = Awaited<ReturnType<typeof v2ProjectsList>>, TError = unknown>(
 params?: V2ProjectsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List projects (v2 lite)
 */

export function useV2ProjectsList<TData = Awaited<ReturnType<typeof v2ProjectsList>>, TError = unknown>(
 params?: V2ProjectsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV2ProjectsListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Same access as v1 without drivers or ai_settings.
 * @summary List project solutions (v2 lite)
 */
export const v2ProjectsSolutionsList = (
    id: string,
    params?: V2ProjectsSolutionsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedProjectSolutionListList>(
      {url: `/api/v2/projects/${id}/solutions/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getV2ProjectsSolutionsListQueryKey = (id: string,
    params?: V2ProjectsSolutionsListParams,) => {
    return [`/api/v2/projects/${id}/solutions/`, ...(params ? [params]: [])] as const;
    }

    
export const getV2ProjectsSolutionsListQueryOptions = <TData = Awaited<ReturnType<typeof v2ProjectsSolutionsList>>, TError = unknown>(id: string,
    params?: V2ProjectsSolutionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsSolutionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV2ProjectsSolutionsListQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v2ProjectsSolutionsList>>> = ({ signal }) => v2ProjectsSolutionsList(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsSolutionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V2ProjectsSolutionsListQueryResult = NonNullable<Awaited<ReturnType<typeof v2ProjectsSolutionsList>>>
export type V2ProjectsSolutionsListQueryError = unknown


export function useV2ProjectsSolutionsList<TData = Awaited<ReturnType<typeof v2ProjectsSolutionsList>>, TError = unknown>(
 id: string,
    params: undefined |  V2ProjectsSolutionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsSolutionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v2ProjectsSolutionsList>>,
          TError,
          Awaited<ReturnType<typeof v2ProjectsSolutionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV2ProjectsSolutionsList<TData = Awaited<ReturnType<typeof v2ProjectsSolutionsList>>, TError = unknown>(
 id: string,
    params?: V2ProjectsSolutionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsSolutionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v2ProjectsSolutionsList>>,
          TError,
          Awaited<ReturnType<typeof v2ProjectsSolutionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV2ProjectsSolutionsList<TData = Awaited<ReturnType<typeof v2ProjectsSolutionsList>>, TError = unknown>(
 id: string,
    params?: V2ProjectsSolutionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsSolutionsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List project solutions (v2 lite)
 */

export function useV2ProjectsSolutionsList<TData = Awaited<ReturnType<typeof v2ProjectsSolutionsList>>, TError = unknown>(
 id: string,
    params?: V2ProjectsSolutionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsSolutionsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV2ProjectsSolutionsListQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Same access and validation as v1 /channels with slim driver payloads.
 * @summary Get channel hierarchy for project solution drivers (v2 lite)
 */
export const v2ProjectsSolutionsChannelsRetrieve = (
    id: string,
    solutionId: string,
    params?: V2ProjectsSolutionsChannelsRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OptimizeChannelDriverListV2Response>(
      {url: `/api/v2/projects/${id}/solutions/${solutionId}/channels`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getV2ProjectsSolutionsChannelsRetrieveQueryKey = (id: string,
    solutionId: string,
    params?: V2ProjectsSolutionsChannelsRetrieveParams,) => {
    return [`/api/v2/projects/${id}/solutions/${solutionId}/channels`, ...(params ? [params]: [])] as const;
    }

    
export const getV2ProjectsSolutionsChannelsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof v2ProjectsSolutionsChannelsRetrieve>>, TError = FailResponse>(id: string,
    solutionId: string,
    params?: V2ProjectsSolutionsChannelsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsSolutionsChannelsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV2ProjectsSolutionsChannelsRetrieveQueryKey(id,solutionId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v2ProjectsSolutionsChannelsRetrieve>>> = ({ signal }) => v2ProjectsSolutionsChannelsRetrieve(id,solutionId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id && solutionId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsSolutionsChannelsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V2ProjectsSolutionsChannelsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof v2ProjectsSolutionsChannelsRetrieve>>>
export type V2ProjectsSolutionsChannelsRetrieveQueryError = FailResponse


export function useV2ProjectsSolutionsChannelsRetrieve<TData = Awaited<ReturnType<typeof v2ProjectsSolutionsChannelsRetrieve>>, TError = FailResponse>(
 id: string,
    solutionId: string,
    params: undefined |  V2ProjectsSolutionsChannelsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsSolutionsChannelsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v2ProjectsSolutionsChannelsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v2ProjectsSolutionsChannelsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV2ProjectsSolutionsChannelsRetrieve<TData = Awaited<ReturnType<typeof v2ProjectsSolutionsChannelsRetrieve>>, TError = FailResponse>(
 id: string,
    solutionId: string,
    params?: V2ProjectsSolutionsChannelsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsSolutionsChannelsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v2ProjectsSolutionsChannelsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof v2ProjectsSolutionsChannelsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV2ProjectsSolutionsChannelsRetrieve<TData = Awaited<ReturnType<typeof v2ProjectsSolutionsChannelsRetrieve>>, TError = FailResponse>(
 id: string,
    solutionId: string,
    params?: V2ProjectsSolutionsChannelsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsSolutionsChannelsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get channel hierarchy for project solution drivers (v2 lite)
 */

export function useV2ProjectsSolutionsChannelsRetrieve<TData = Awaited<ReturnType<typeof v2ProjectsSolutionsChannelsRetrieve>>, TError = FailResponse>(
 id: string,
    solutionId: string,
    params?: V2ProjectsSolutionsChannelsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsSolutionsChannelsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV2ProjectsSolutionsChannelsRetrieveQueryOptions(id,solutionId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Same validation as v1 /drivers with a slim driver payload for build-model UIs. Supports pagination via page/limit and optional search on driver name.
 * @summary Get project solution drivers (v2 lite)
 */
export const v2ProjectsSolutionsDriversList = (
    id: string,
    solutionId: string,
    params?: V2ProjectsSolutionsDriversListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedProjectSolutionDriverListV2ResponseList>(
      {url: `/api/v2/projects/${id}/solutions/${solutionId}/drivers`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getV2ProjectsSolutionsDriversListQueryKey = (id: string,
    solutionId: string,
    params?: V2ProjectsSolutionsDriversListParams,) => {
    return [`/api/v2/projects/${id}/solutions/${solutionId}/drivers`, ...(params ? [params]: [])] as const;
    }

    
export const getV2ProjectsSolutionsDriversListQueryOptions = <TData = Awaited<ReturnType<typeof v2ProjectsSolutionsDriversList>>, TError = FailResponse>(id: string,
    solutionId: string,
    params?: V2ProjectsSolutionsDriversListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsSolutionsDriversList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV2ProjectsSolutionsDriversListQueryKey(id,solutionId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof v2ProjectsSolutionsDriversList>>> = ({ signal }) => v2ProjectsSolutionsDriversList(id,solutionId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id && solutionId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsSolutionsDriversList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V2ProjectsSolutionsDriversListQueryResult = NonNullable<Awaited<ReturnType<typeof v2ProjectsSolutionsDriversList>>>
export type V2ProjectsSolutionsDriversListQueryError = FailResponse


export function useV2ProjectsSolutionsDriversList<TData = Awaited<ReturnType<typeof v2ProjectsSolutionsDriversList>>, TError = FailResponse>(
 id: string,
    solutionId: string,
    params: undefined |  V2ProjectsSolutionsDriversListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsSolutionsDriversList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v2ProjectsSolutionsDriversList>>,
          TError,
          Awaited<ReturnType<typeof v2ProjectsSolutionsDriversList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV2ProjectsSolutionsDriversList<TData = Awaited<ReturnType<typeof v2ProjectsSolutionsDriversList>>, TError = FailResponse>(
 id: string,
    solutionId: string,
    params?: V2ProjectsSolutionsDriversListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsSolutionsDriversList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v2ProjectsSolutionsDriversList>>,
          TError,
          Awaited<ReturnType<typeof v2ProjectsSolutionsDriversList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV2ProjectsSolutionsDriversList<TData = Awaited<ReturnType<typeof v2ProjectsSolutionsDriversList>>, TError = FailResponse>(
 id: string,
    solutionId: string,
    params?: V2ProjectsSolutionsDriversListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsSolutionsDriversList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project solution drivers (v2 lite)
 */

export function useV2ProjectsSolutionsDriversList<TData = Awaited<ReturnType<typeof v2ProjectsSolutionsDriversList>>, TError = FailResponse>(
 id: string,
    solutionId: string,
    params?: V2ProjectsSolutionsDriversListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v2ProjectsSolutionsDriversList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV2ProjectsSolutionsDriversListQueryOptions(id,solutionId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * One-shot select-all / select-none for the solution configure driver grid. Operates on the client's active dataset grants (optional `search` on name). `is_active=true` assigns missing grants to the solution; `is_active=false` removes matching assigned drivers.
 * @summary Bulk set project solution drivers active/inactive (v2)
 */
export const v2ProjectsSolutionsDriversBulkActiveCreate = (
    id: string,
    solutionId: string,
    projectSolutionDriverBulkActiveRequestRequest: ProjectSolutionDriverBulkActiveRequestRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ProjectSolutionDriverBulkActiveResponse>(
      {url: `/api/v2/projects/${id}/solutions/${solutionId}/drivers/bulk-active/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: projectSolutionDriverBulkActiveRequestRequest, signal
    },
      );
    }
  


export const getV2ProjectsSolutionsDriversBulkActiveCreateMutationOptions = <TError = FailResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v2ProjectsSolutionsDriversBulkActiveCreate>>, TError,{id: string;solutionId: string;data: ProjectSolutionDriverBulkActiveRequestRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof v2ProjectsSolutionsDriversBulkActiveCreate>>, TError,{id: string;solutionId: string;data: ProjectSolutionDriverBulkActiveRequestRequest}, TContext> => {

const mutationKey = ['v2ProjectsSolutionsDriversBulkActiveCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v2ProjectsSolutionsDriversBulkActiveCreate>>, {id: string;solutionId: string;data: ProjectSolutionDriverBulkActiveRequestRequest}> = (props) => {
          const {id,solutionId,data} = props ?? {};

          return  v2ProjectsSolutionsDriversBulkActiveCreate(id,solutionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type V2ProjectsSolutionsDriversBulkActiveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof v2ProjectsSolutionsDriversBulkActiveCreate>>>
    export type V2ProjectsSolutionsDriversBulkActiveCreateMutationBody = ProjectSolutionDriverBulkActiveRequestRequest
    export type V2ProjectsSolutionsDriversBulkActiveCreateMutationError = FailResponse

    /**
 * @summary Bulk set project solution drivers active/inactive (v2)
 */
export const useV2ProjectsSolutionsDriversBulkActiveCreate = <TError = FailResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v2ProjectsSolutionsDriversBulkActiveCreate>>, TError,{id: string;solutionId: string;data: ProjectSolutionDriverBulkActiveRequestRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v2ProjectsSolutionsDriversBulkActiveCreate>>,
        TError,
        {id: string;solutionId: string;data: ProjectSolutionDriverBulkActiveRequestRequest},
        TContext
      > => {

      const mutationOptions = getV2ProjectsSolutionsDriversBulkActiveCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    